function requireEnv(key: string): string {
  const val = import.meta.env[key];
  if (!val) throw new Error(`[Config] ${key} is not set. Check your .env file.`);
  return val as string;
}

export const env = {
  API_BASE_URL: requireEnv('VITE_API_BASE_URL'),
  CLOUDINARY_CLOUD_NAME: requireEnv('VITE_CLOUDINARY_NAME'),
  CLOUDINARY_UPLOAD_PRESET: requireEnv('VITE_CLOUDINARY_PRESET'),
  DEV: import.meta.env.DEV,
  TAWK_PROPERTY_ID: import.meta.env.VITE_TAWK_PROPERTY_ID as string | undefined,
  TAWK_WIDGET_ID: import.meta.env.VITE_TAWK_WIDGET_ID as string | undefined,
};
